<p class="disclaimer">
  <ng-content> </ng-content>
</p>
